var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Spinner from "@cloudscape-design/components/spinner";
var DEFAULT_LOADING_TEXT = "Loading";
export var LoadingSpinner = function (_a) {
    var ariaLabel = _a.ariaLabel;
    return (_jsx("span", __assign({ "aria-live": "polite", "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : DEFAULT_LOADING_TEXT }, { children: _jsx(Spinner, {}) })));
};
